var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Separator } from '@lucidlink/uicore';
import { useAuthProvider } from '#context';
import { useCurrentMemberByWorkspaceId, useWorkspaceById } from '#query-hooks';
import { checkIsEnterprise } from '#services';
import { FilespaceDelete } from './components';
import { FilespaceAccessControl } from './components/FilespaceAccessControl';
import { FilespaceRename } from './components/FilespaceRename';
export const GeneralSettings = ({ filespaceData }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { currentUser } = useAuthProvider();
    const { query: { data: currentMemberData }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { query: { data: workspaceData, isPending: isPendingWorkspaceData }, } = useWorkspaceById(workspaceId);
    const isEnterprise = useMemo(() => {
        if (isPendingWorkspaceData) {
            return false;
        }
        return checkIsEnterprise(workspaceData?.billing);
    }, [isPendingWorkspaceData, workspaceData]);
    const isSuspended = useMemo(() => (workspaceData ? workspaceData.isSuspended : true), [workspaceData]);
    return (_jsxs(Box, { "data-testid": "filespace-general-settings", gap: "xl", orientation: "vertical", children: [!isSuspended && (_jsxs(_Fragment, { children: [currentMemberData?.privileges.filespaceCrud && (_jsxs(_Fragment, { children: [_jsx(FilespaceRename, { filespace: filespaceData }), _jsx(Separator, {})] })), _jsx(FilespaceAccessControl, { filespaceData: filespaceData, isEnterprise: isEnterprise })] })), currentMemberData?.privileges.filespaceCrud && (_jsxs(_Fragment, { children: [_jsx(Separator, {}), _jsx(FilespaceDelete, { currentUser: currentUser, filespace: filespaceData })] }))] }));
};
_react_refresh_temp_1 = GeneralSettings;
$RefreshReg$(_react_refresh_temp_1, "GeneralSettings");
_react_refresh_temp_2(GeneralSettings, "bL7b/aWtjJYHDVRF45m5OE52vvo=", false, () => [useParams, useAuthProvider, useCurrentMemberByWorkspaceId, useWorkspaceById]);
